var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoveIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5914 11.1684C1.0989 9.93476 -0.0496774 8.14668 0.00165552 6.0612C0.0837883 2.76653 2.90068 0.0801243 6.35411 0.00179636C9.10812 -0.0606212 11.4861 1.50961 12.4999 3.76888C13.5138 1.50961 15.8918 -0.0593974 18.6458 0.00179636C22.1005 0.0789004 24.9174 2.76653 24.9982 6.05997C25.0496 8.14668 23.9741 9.88948 22.4098 11.1684L12.4999 19L2.5914 11.1684Z",
    fill: "#FF75C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoveIcon);
export default __webpack_public_path__ + "static/media/love_icon.9609d1dfa707b11e52bd36e20684f5d0.svg";
export { ForwardRef as ReactComponent };